// extracted by mini-css-extract-plugin
export var divider = "_2s-0";
export var dividerText = "_2s-1";